module.exports = __webpack_public_path__ + "static/banner-abbb753c1c26f3f77ced06f49d6df1ea.png";